import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconVehicle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 22,
	viewBox: "0 0 24 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.2267 1.34667C20.96 0.56 20.2133 0 19.3333 0H4.66667C3.78667 0 3.05333 0.56 2.77333 1.34667L0.146667 8.90667C0.0533332 9.18667 0 9.48 0 9.78667V19.3333C0 20.44 0.893333 21.3333 2 21.3333C3.10667 21.3333 4 20.44 4 19.3333V18.6667H20V19.3333C20 20.4267 20.8933 21.3333 22 21.3333C23.0933 21.3333 24 20.44 24 19.3333V9.78667C24 9.49333 23.9467 9.18667 23.8533 8.90667L21.2267 1.34667ZM4.66667 14.6667C3.56 14.6667 2.66667 13.7733 2.66667 12.6667C2.66667 11.56 3.56 10.6667 4.66667 10.6667C5.77333 10.6667 6.66667 11.56 6.66667 12.6667C6.66667 13.7733 5.77333 14.6667 4.66667 14.6667ZM19.3333 14.6667C18.2267 14.6667 17.3333 13.7733 17.3333 12.6667C17.3333 11.56 18.2267 10.6667 19.3333 10.6667C20.44 10.6667 21.3333 11.56 21.3333 12.6667C21.3333 13.7733 20.44 14.6667 19.3333 14.6667ZM2.66667 8L4.36 2.90667C4.54667 2.37333 5.05333 2 5.62667 2H18.3733C18.9467 2 19.4533 2.37333 19.64 2.90667L21.3333 8H2.66667Z",
		fill: "currentColor"
	})
});
export default SvgIconVehicle;
